import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignerInfoComponent } from './components/campaigner-info/campaigner-info.component';
import { SharedModule } from '../../shared/shared.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { DonorModule } from '../donor/donor.module';
import { ContactDialogModule } from '../contact-dialog/contact-dialog.module';
import { PopoverLoaderModule } from '../popover-loader/popover-loader.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FrCardModule,
    DonorModule,
    ContactDialogModule,
    PopoverLoaderModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule
  ],
  declarations: [CampaignerInfoComponent],
  exports: [CampaignerInfoComponent],
})
export class CampaignerInfoModule { }
